import type { FinanceProduct, ListResponseFinancialProductLine } from "@classes-service-types/index.ts";
import type { UseQueryReturnType } from "@tanstack/vue-query";
import { type UseQueryOptions, useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import financialProductLines from "@/services/financialProductLines.js";

interface Args {
  limit: number;
  page: number;
  q: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<FinanceProduct[]>>;
}

type UseGetFinancialLinesDataFunc = (args: Args) => UseQueryReturnType<FinanceProduct[], Error>;

export const useGetFinancialLinesData: UseGetFinancialLinesDataFunc = ({ limit, page, q, useQueryOptions }) => {
  const fetchFinancialLines = (): Promise<FinanceProduct[]> =>
    financialProductLines
      .getFinancialProductLines({ limit: limit, page: page, q: q?.value ?? "" })
      .then((val: { data?: ListResponseFinancialProductLine }) => val?.data?.data?.items);
  return useQuery<FinanceProduct[]>({
    queryKey: computed(() => ["financialLines", limit, page, q]),
    queryFn: fetchFinancialLines,
    ...useQueryOptions,
  });
};
